import React from 'react';
import { ToggleButton, Paper, Tooltip } from '@mui/material';
import { LabelOutlined } from '@mui/icons-material';
import { useMap } from 'react-map-gl/maplibre';

export const ToggleLabelsButton = (props: { initialVisibility?: 'none' | 'visible' }) => {
  const { current: mapRef } = useMap();
  const map = mapRef?.getMap();
  const [labelsVisible, setLabelsVisible] = React.useState(
    props.initialVisibility === 'none' ? false : true
  );

  const handleChange = React.useCallback(() => {
    setLabelsVisible(!labelsVisible);
    if (map) {
      map.getStyle().layers.forEach(l => {
        if (l.type === 'symbol') {
          map.setLayoutProperty(l.id, 'visibility', labelsVisible ? 'none' : 'visible');
        }
      });
    }
  }, [setLabelsVisible, labelsVisible, map]);

  React.useEffect(() => {
    try {
      if (map && props.initialVisibility === 'none') {
        setTimeout(() => {
          const style = map?.getStyle();
          if (style && style.layers) {
            style.layers.forEach(l => {
              if (l.type === 'symbol') {
                map.setLayoutProperty(l.id, 'visibility', 'none');
              }
            });
          }
        }, 200);
      }
    } catch (e) {
      console.error('Error setting initial label visibility:', e);
    }
  }, [map, props.initialVisibility]);

  return (
    <Tooltip title="Show or hide the place names and road labels on the basemap" describeChild>
      <Paper elevation={0}>
        <ToggleButton
          size="small"
          value="check"
          sx={{ backgroundColor: 'white', width: 30, height: 30 }}
          selected={labelsVisible}
          onChange={handleChange}
          aria-label="Toggle labels"
        >
          <LabelOutlined />
        </ToggleButton>
      </Paper>
    </Tooltip>
  );
};
